module.exports = __webpack_public_path__ + "images/construction-d84524a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/slider-v1/images/construction.gif
// module id = 108
// module chunks = 2